/**
 * Creates a type guard for a given enum.
 *
 * @see https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 * @example
 * ```
 * enum Size {
 *   Small = "Small",
 *   Medium = "Medium",
 *   Large = "Large",
 *}
 *
 * // We create a function that will check if something is an element of Size.
 * // `isSize` seems like a good name for it.
 * export const isSize = createEnumTypeGuard(Size);
 *
 * // We can now check if various things are a "Size"
 * console.log(isSize("woof")); // false
 * console.log(isSize(Size.Large)); // true
 * ```
 */
export const createEnumTypeGuard = (theEnum) => (token) => Object.values(theEnum).includes(token);
//# sourceMappingURL=createEnumTypeGuard.js.map